import * as React from 'react'

import { VerticalContext } from 'common/context'
import { DynamicCx } from 'common/types'
import { isMyService, SubVertical, subVerticalConfig } from 'common/constants'
import Header from '../Header'
import Footer from '../Footer'
import Popup from 'common/components/Layer/Popup'
import { styling } from 'common/utils'
import * as s from './layout.scss'

interface OwnProps {
  pathname: string
  hideHeaderFooter: boolean
  children?: any
  cx?: DynamicCx
  subVertical?: SubVertical
}

type Props = OwnProps

const Layout: React.SFC<Props> = ({ pathname, children, hideHeaderFooter, cx, subVertical }) => {
  const vertical = subVertical && subVerticalConfig[subVertical].vertical
  return (
    <VerticalContext.Provider value={{ vertical, subVertical, pathname }}>
      <div className={cx('wrap', { '@shopping_my': isMyService(pathname) })}>
        {!hideHeaderFooter && <Header />}
        {children}
        {!hideHeaderFooter && <Footer {...{ vertical }} />}
        <Popup />
        <Popup overPopup={true} />
      </div>
    </VerticalContext.Provider>
  )
}

export default styling(s)(Layout)
